/**
 * The service status chip (DNKADM-0493): Draft / Turned off / Active, with its one-line
 * meaning shown on hover or tap (a tooltip that opens on touch with no delay). Read from
 * the existing lifecycle value; used by the service page header and the services list.
 */
import { Chip, Tooltip } from '@mui/material';
import type { V2Service } from '@/api/services';
import { SERVICE_STATUS_WORDS } from './serviceLabels';

export function ServiceStatusChip({ status }: { status: V2Service['status'] }) {
  const words = SERVICE_STATUS_WORDS[status];
  const color = status === 'DRAFT' ? 'warning' : status === 'INACTIVE' ? 'default' : 'success';
  return (
    <Tooltip title={words.meaning} placement="bottom" enterTouchDelay={0} describeChild>
      <Chip
        size="small"
        label={words.label}
        color={color}
        variant={status === 'ACTIVE' ? 'filled' : 'outlined'}
        // Focusable so a keyboard user reaches the meaning too (the tooltip opens on focus).
        tabIndex={0}
        onClick={(event) => event.stopPropagation()}
      />
    </Tooltip>
  );
}
